import $axios from '~/plugins/axios';

import { Api, CampaignSplitFilterGroup, GetCampaignSplitFilterGroupParams, PaginatorResult } from '~/api';
import { buildModule, createPaginationModule } from '~/store/utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignSplitFilterGroupsPage',
			pageSizeQueryKey: 'campaignSplitFilterGroupsPerPage',
			itemCountGetter: 'campaignSplitFilters/groups/list/totalCount',
		}),
	})
	.withState({
		storedCampaignSplitFilterGroups: {} as Dict<CampaignSplitFilterGroup>,
		campaignSplitFilterGroups: [] as CampaignSplitFilterGroup[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (filterGroupId: CampaignSplitFilterGroup['id']): CampaignSplitFilterGroup | null => (
			state.storedCampaignSplitFilterGroups[filterGroupId] ?? null
		),
		page: state => state.campaignSplitFilterGroups,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_SPLIT_FILTER_GROUPS (state, filterGroups: CampaignSplitFilterGroup[]) {
			state.storedCampaignSplitFilterGroups = {
				...state.storedCampaignSplitFilterGroups,
				...createDict(filterGroups, (filterGroup) => filterGroup.id),
			};
		},
		SET_CAMPAIGN_SPLIT_FILTER_GROUPS (state, filterGroupIds: CampaignSplitFilterGroup['id'][]) {
			state.campaignSplitFilterGroups = filterGroupIds.map(id => state.storedCampaignSplitFilterGroups[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignSplitFilterGroupParams = { inFuture: false, inPast: false }) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign/split/filter-group', { params });
			commit('SET_LOADING', false);

			const filterGroups = data.payload;
			const filterGroupIds = filterGroups.map(filterGroup => filterGroup.id);

			commit('SET_STORED_CAMPAIGN_SPLIT_FILTER_GROUPS', filterGroups);
			commit('SET_CAMPAIGN_SPLIT_FILTER_GROUPS', filterGroupIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
